// extracted by mini-css-extract-plugin
module.exports = {"image":"BlogImageWithCaption_image__NJWjc","nextImageContainer":"BlogImageWithCaption_nextImageContainer__m7lru"};